// reservation/hooks/useReservation.ts

import { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../recoil/pub.atom";
import {
  getMyReservation,
  SellerReservationDto,
} from "../../../api/reservation";

interface UseReservationReturn {
  list: SellerReservationDto[];
  currentPage: number;
  totalPages: number;
  handlePageChange: (page: number) => void;
  getMyReservations: () => Promise<void>;
  CopyReservationLink: (reservation: SellerReservationDto) => Promise<void>;
}

export const useReservation = (
  itemsPerPage: number = 10,
): UseReservationReturn => {
  const pub = useRecoilValue(pubState);

  const [list, setList] = useState<SellerReservationDto[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getMyReservations = async () => {
    if (!pub) return;
    setList([]);
    const res = await getMyReservation(pub.id, currentPage);

    setList(res.data);
    setTotalPages(Math.max(1, Math.ceil(res.total / itemsPerPage)));
  };

  const CopyReservationLink = async (reservation: SellerReservationDto) => {
    const url = `${process.env.REACT_APP_HOST_URL}/tournament/${reservation.tournamentId}`;
    await navigator.clipboard.writeText(url);
    alert(
      `${process.env.REACT_APP_HOST_URL}/tournament/${reservation.tournamentId}\n링크가 복사되었습니다.`,
    );
  };

  useEffect(() => {
    getMyReservations();
  }, [currentPage]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return {
    list,
    currentPage,
    totalPages,
    handlePageChange,
    getMyReservations,
    CopyReservationLink,
  };
};
